export default "__VITE_ASSET__c5e31316__"